import { Stack } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { SMALL_SCREEN_MAX_WIDTH } from 'shared/constants/layout';

function ReactivationLayoutWeb() {
  return (
    <View style={styles.container}>
      <Stack screenOptions={{ headerShown: false }} />
    </View>
  );
}

export default ReactivationLayoutWeb;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 'auto',
    maxWidth: SMALL_SCREEN_MAX_WIDTH,
    width: '100%',
  },
});
